import tw, { styled } from 'twin.macro';

const Input = tw.input`w-full rounded-lg border-2 bg-gray-50 px-3 py-2 focus:(border-primary bg-white outline-none)`;

export default Input;
